import React, { useState, useEffect, Fragment } from 'react';
import ReactDOM from 'react-dom';
import cn from 'classnames';
import ChatMessage from '../../common/components/ChatMessage';
import { chatNewMessagesStr } from '../modules/common';

export class Messages extends React.Component {
  constructor(props) {
    super(props);
  }

  scrollToBottom = () => {
    const messagesContainer = this.getContainer();
    messagesContainer.scrollTop = messagesContainer.scrollHeight - messagesContainer.offsetHeight;
  };

  getContainer = () => {
    return ReactDOM.findDOMNode(this.messagesContainer);
  };

  isElementInView = (container, element) => {
    const pageTop = container.scrollTop + 70;
    const pageBottom = pageTop + container.clientHeight - 50;
    const elementTop = element.offsetTop;
    const elementBottom = elementTop + element.clientHeight;

    const inView =
      (elementTop >= pageTop && elementBottom <= pageBottom) ||
      (elementTop <= pageBottom && elementBottom >= pageTop) ||
      (elementTop <= pageBottom && elementBottom >= pageBottom);
    // if (inView) {
    //   element.style.backgroundColor = 'green';
    // } else {
    //   element.style.backgroundColor = 'yellow';
    // }
    return inView;
  };

  scrollToMessage = (container, element) => {
    const pageTop = container.scrollTop;
    const pageBottom = pageTop + container.clientHeight;
    const elementTop = element.offsetTop;
    const elementBottom = elementTop + element.clientHeight;
    container.scrollTop = elementBottom - pageBottom + pageTop;
  };

  markMessagesRead = container => {
    const {
      props: {
        readMessages,
        chat: { id: chatId },
      },
    } = this;
    const unreadElements = [];
    container
      .querySelectorAll('.chat-list_line-wrapper.-message-unread')
      .forEach(commentElement => {
        if (this.isElementInView(container, commentElement)) {
          commentElement.classList.add('-message-seen');
          unreadElements.push(commentElement);
        }
      });
    if (unreadElements.length === 0) return;
    const messageIds = unreadElements.map(m => m.getAttribute('message_id'));
    setTimeout(() => {
      readMessages(chatId, messageIds);
    });
  };

  processScroll = e => {
    // console.log('onScroll');
    if (e.target.scrollTop === 0) {
      const {
        props,
        props: { messages },
      } = this;
      if (messages && messages.length > 0) {
        // todo: need to pass s paramter somehow
        props.loadPrevPage({ chatId: props.chat.id, timestamp: messages[0].timestamp });
      }
    }
    this.markMessagesRead(e.target);
  };

  navigateUnread = () => {
    const messagesContainer = this.getContainer();
    const unreadMessageElements = messagesContainer.querySelectorAll(
      '.chat-list_line-wrapper.-message-unread',
    );
    messagesContainer.style.scrollBehavior = 'smooth';
    if (unreadMessageElements.length > 0) {
      this.scrollToMessage(messagesContainer, unreadMessageElements[0]);
    } else {
      this.scrollToBottom();
    }
    setTimeout(() => {
      messagesContainer.style.scrollBehavior = 'initial';
    }, 500);
  };

  isWindowActive = () => {
    return document.hidden;
  };

  preloadMessages = () => {
    const { loadLastMessages, chat, timestamp } = this.props;
    loadLastMessages({ chatId: chat.id });
  };

  componentDidMount() {
    const { chat } = this.props;
    if (chat && chat.id) {
      this.subscribeToChatChannel({ id: chat.id });
      this.preloadMessages();
    }
  }

  componentWillUnmount() {
    this.unsubscribeChatChannel();
  }

  onConnected(params) {
    console.log('on connected: ', params);
  }

  onDisconnected(params) {
    console.log('on discconnected: ', params);
  }

  subscribeToChatChannel(chat) {
    const { onNewMessages, me } = this.props;
    const onNewData = data => {
      const message = JSON.parse(data.message);
      const scrollToBottomEffect = message.user.id === me.id;
      onNewMessages([message], scrollToBottomEffect);
    };
    this.chatChannel = App.cable.subscriptions.create(
      {
        channel: 'ChatChannel',
        room: `room:${chat.id}`,
      },
      {
        connected: this.onConnected,
        disconnected: this.onDisconnected,
        received: onNewData,
      },
    );
  }

  unsubscribeChatChannel() {
    if (this.chatChannel) {
      this.chatChannel.unsubscribe();
    }
  }

  componentWillUpdate() {
    const messagesContainer = this.getContainer();
    this.needScrollFromTop = messagesContainer.scrollTop === 0;
    this.previousHeight = messagesContainer.scrollHeight;
  }

  componentDidUpdate(prevProps) {
    const { chat, messages, toggleScrollToBottomEffect, scrollToBottomEffect, me } = this.props;
    if (chat.id !== prevProps.chat.id) {
      this.unsubscribeChatChannel();
      this.subscribeToChatChannel({ id: chat.id });
      this.preloadMessages();
      return;
    }
    if (chat.id === prevProps.chat.id && messages.length !== prevProps.messages.length) {
      if (scrollToBottomEffect) {
        toggleScrollToBottomEffect(false);
        this.scrollToBottom();
        // setTimeout(() => this.scrollToBottom());
      }
      this.markMessagesRead(this.getContainer());
      if (this.needScrollFromTop) {
        const messagesContainer = this.getContainer();
        // const height = messagesContainer.scrollHeight - messagesContainer.offsetHeight;
        messagesContainer.scrollTop = messagesContainer.scrollHeight - this.previousHeight;
      }
    }
  }

  hideInitials = message => {
    const lastMessage = this.lastMessageMemo;
    this.lastMessageMemo = message;
    if (message.user.me) {
      return true;
    }
    if (!lastMessage) {
      return false;
    }
    let hide = message.user.id === lastMessage.user.id;
    hide = hide && message.created_at_date === lastMessage.creared_at_date;
    return hide;
  };

  render() {
    const {
      popup,
      messages,
      labels,
      openLightbox,
      role,
      messagesInitialized,
      messagesInitializationError,
      chat,
    } = this.props;
    const containerStyles = cn({
      'chat-popup_scroll-wrapper': popup,
      'chat-wrapper_scroll': !popup,
    });
    return (
      <Fragment>
        <div
          className={containerStyles}
          ref={el => {
            this.messagesContainer = el;
          }}
          onScroll={this.processScroll}
        >
          {messagesInitialized &&
            messages.length > 0 && (
              <div className="chat-list">
                {messages.map(message => (
                  <ChatMessage
                    key={message.id}
                    message={message}
                    // me={me}
                    labels={labels}
                    onAttachmentClick={openLightbox}
                    role={role}
                    hideInitials={this.hideInitials(message)}
                  />
                ))}
              </div>
            )}
          {messagesInitialized &&
            messages.length === 0 && (
              <div className="chat-list_center-message">No messages received</div>
            )}
          {!messagesInitialized &&
            !messagesInitializationError &&
            messages.length === 0 && <div className="chat-list_center-message">loading ...</div>}
          {messagesInitializationError && (
            <div className="chat-list_center-message">
              <div className="chat-list_center-message_error">
                <p> network error</p>
                <p>
                  <button onClick={this.preloadMessages} className="btn -gold">
                    Retry
                  </button>
                </p>
              </div>
            </div>
          )}
        </div>
        {messagesInitialized &&
          chat.new_messages_count > 0 &&
          messages.length > 0 && (
            <div className="chat-list_unread-messages-navigator_wrapper">
              <div
                className="chat-list_unread-messages-navigator_btn"
                onClick={this.navigateUnread}
              >
                <div className="arrow" />
                <div className="new-messages-count">
                  {chatNewMessagesStr(chat.new_messages_count)}
                </div>
              </div>
            </div>
          )}
      </Fragment>
    );
  }
}

export default Messages;



// WEBPACK FOOTER //
// ./app/javascript/chat/components/Messages.js